export const SET_USER_SESSION = 'SET_USER_SESSION';
export const CLEAR_USER_SESSION = 'CLEAR_USER_SESSION';

/**
 * Seed the userSession slice from a full _oauth / _whoami API response.
 * Permissions live only in Redux after this — not re-read from localStorage.
 *
 * The oauth login response may store clinic_uuid inside User.additionalInfo.clinicUUID
 * while the _whoami response puts it at User.clinic_uuid (top level). We normalise
 * here so that wrapRequestBody always finds clinic_uuid at userSession.user.clinic_uuid
 * regardless of which endpoint seeded the store.
 */
export const setUserSession = (apiResponse) => {
  const rawUser = apiResponse.User || null;
  const normalizedUser = rawUser
    ? {
        ...rawUser,
        clinic_uuid:
          rawUser.clinic_uuid ||
          rawUser.additionalInfo?.clinicUUID ||
          null,
      }
    : null;

  return {
    type: SET_USER_SESSION,
    payload: {
      user: normalizedUser,
      permissions: rawUser?.additionalInfo?.permissions || [],
      authToken: apiResponse.OAuthDetails?.authToken || null,
      refreshToken: apiResponse.OAuthDetails?.refreshToken || null,
      chatSDKAuthDetails: apiResponse.chatSDKAuthDetails || null,
      isHydrated: true,
    },
  };
};

export const clearUserSession = () => ({ type: CLEAR_USER_SESSION });
